import React from "react";

const AniDivider = () => (
  <hr data-token="Ani Divider" className="ani-divider ani-tint" />
);

export default AniDivider;
